import { useState } from 'react';
import TournamentModalForm from './components/TournamentModalForm';
import TournamentsTable from './components/TournamentsTable';
import StandardLayout from '@/common/layouts/StandardLayout';
import { FaPlus } from 'react-icons/fa';
import { Button } from 'reactstrap';

const TournamentsPage = () => {
  const [formOpen, setFormOpen] = useState(false);

  const openForm = () => setFormOpen(true);
  const closeForm = () => setFormOpen(false);

  return (
    <StandardLayout
      pageTitle="Tournaments"
      headerButton={
        <Button onClick={openForm} color="primary" className="d-flex align-items-center gap-2">
          <FaPlus />
          <p className="mb-0">Add Tournament</p>
        </Button>
      }
    >
      <TournamentsTable />
      {formOpen && <TournamentModalForm onClose={closeForm} />}
    </StandardLayout>
  );
};

export default TournamentsPage;
